import { Stack } from '@mui/material';
import { useField } from 'formik';
import { Checkbox, CheckboxProps } from '../Checkbox';
import { FormFieldError } from './FormFieldError';

type FormCheckboxProps = CheckboxProps & { name: string };

export const FormCheckbox = ({ maintainGutters = true, name, ...props }: FormCheckboxProps) => {
  const [field, meta] = useField(name);
  const error = meta?.touched && meta?.error;
  return (
    <Stack>
      <Checkbox checked={field.value as boolean} {...props} {...field} name={name} />
      <FormFieldError error={error} maintainGutters={maintainGutters} />
    </Stack>
  );
};
